const WASM_BASE =
  (process.env.VITE_MC_WASM_BASE ?? '/wasm/mc').replace(/\/$/, '');

type McAesGcmDecryptFn = (
  packedBase64: string,
  keyBase64: string
) => Promise<string>;

interface McCryptoGlobal {
  __mcAesGcmDecrypt?: McAesGcmDecryptFn;
}

function mcCryptoGlobal(): McCryptoGlobal {
  return globalThis as McCryptoGlobal;
}

let cryptoHelperLoaded = false;

async function ensureMcCryptoHelper(): Promise<void> {
  const g = mcCryptoGlobal();
  if (cryptoHelperLoaded && g.__mcAesGcmDecrypt) return;
  await import(/* webpackIgnore: true */ `${WASM_BASE}/mc-crypto.js`);
  if (!mcCryptoGlobal().__mcAesGcmDecrypt) {
    throw new Error('MC crypto helper failed to load.');
  }
  cryptoHelperLoaded = true;
}

/** Decrypt server bootstrap cipher via Web Crypto (AES-GCM). Returns base64 plaintext for WASM. */
export async function decryptMcBootstrapCipher(
  cipherBase64: string,
  keyBase64: string
): Promise<string> {
  await ensureMcCryptoHelper();
  const decrypt = mcCryptoGlobal().__mcAesGcmDecrypt;
  if (!decrypt) {
    throw new Error('MC crypto helper failed to load.');
  }
  return decrypt(cipherBase64, keyBase64);
}
